
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Trophy, Star, GraduationCap, ChevronDown, ChevronUp } from "lucide-react";
import { GradeLevelCompletion } from "@/utils/milestoneUtils";
import { useState } from "react";

interface GradeLevelCardProps {
  gradeLevel: GradeLevelCompletion;
}

export const GradeLevelCard = ({ gradeLevel }: GradeLevelCardProps) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center justify-between text-lg cursor-pointer" onClick={() => setIsExpanded(!isExpanded)}>
          <div className="flex items-center">
            <GraduationCap className="mr-2 h-5 w-5 text-primary" />
            {gradeLevel.gradeLevel}
          </div>
          {isExpanded ? (
            <ChevronUp className="h-5 w-5 text-muted-foreground" />
          ) : (
            <ChevronDown className="h-5 w-5 text-muted-foreground" />
          )}
        </CardTitle>
      </CardHeader>
      {isExpanded && (
        <CardContent>
          <div className="space-y-4">
            {gradeLevel.completed && (
              <div className="rounded-lg bg-primary/10">
                <div className="flex items-center p-2 sm:p-3">
                  <Trophy className="h-5 w-5 mr-2 text-primary flex-shrink-0" />
                  <span className="font-medium">
                    {gradeLevel.gradeLevel} Stage Complete!
                  </span>
                </div>
                <div className="border-t border-primary/20 px-2 py-1.5 sm:px-3 sm:py-2 flex justify-between items-center">
                  <span className="text-sm text-muted-foreground">
                    {gradeLevel.completedTests}/{gradeLevel.totalTests} tests
                  </span>
                  {gradeLevel.averageScore !== undefined && (
                    <span className="text-sm font-medium text-primary">
                      Avg: {gradeLevel.averageScore}%
                    </span>
                  )}
                </div>
              </div>
            )}

            <div className="grid gap-3">
              {gradeLevel.categories
                .filter(category => category.completed)
                .map((category) => (
                  <div
                    key={category.category}
                    className="rounded-lg bg-primary/10"
                  >
                    <div className="flex items-center p-2 sm:p-3">
                      <Star className="h-4 w-4 mr-2 text-primary flex-shrink-0" />
                      <span className="text-sm sm:text-base">
                        All {category.category} Tests Complete
                      </span>
                    </div>
                    <div className="border-t border-primary/20 px-2 py-1.5 sm:px-3 sm:py-2 flex justify-between items-center">
                      <span className="text-sm text-muted-foreground">
                        {category.completedTests}/{category.totalTests} completed
                      </span>
                      {category.averageScore !== undefined && (
                        <span className="text-sm font-medium text-primary">
                          Avg: {category.averageScore}%
                        </span>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </CardContent>
      )}
    </Card>
  );
};
